var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"game-tr-text-area",class:[{ 'position-inherit': _vm.elementTopPosition ? false : true }],style:('top:' +
      _vm.elementTopPosition +
      ';left:' +
      _vm.elementLeftPosition +
      ';width:' +
      _vm.elementWidth +
      ';height:' +
      _vm.elementHeight +
      ';')},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.textAreaVal),expression:"textAreaVal"}],staticClass:"tr-text-area tr-text-area-text",class:[
      { 'tr-text-area-disabled': _vm.getTextAreaData().block === true },
      { 'tr-text-area-correct': _vm.getTextAreaData().inputStatus === 'correct' },
      { 'tr-text-area-wrong': _vm.getTextAreaData().inputStatus === 'incorrect' },
      { 'tr-text-area-text-aling-center': _vm.elementTextAlign === 'center' },
      { 'tr-text-area-text-aling-left': _vm.elementTextAlign === 'left' },
      { 'tr-text-area-text-aling-right': _vm.elementTextAlign === 'right' },
    ],style:('font-size:' + _vm.textAreaFontSize + ';'),attrs:{"maxlength":_vm.maxLength,"disabled":_vm.getTextAreaData().block === true},domProps:{"value":(_vm.textAreaVal)},on:{"click":_vm.resetCheckStatus,"input":function($event){if($event.target.composing)return;_vm.textAreaVal=$event.target.value}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }